import {useQuery} from "@tanstack/react-query";
import {REPORT_ENDPOINTS} from "../../services/network/endpoints";
import {ReportAPI} from "../../services/network/report-api";

export function useFetchReportsLogs(page: number, limit: number) {

    const {data, error, isLoading} = useQuery({
        queryKey: [REPORT_ENDPOINTS.FETCH, page, limit],
        queryFn: () => ReportAPI.fetchReportsLogs(
            page || 1,
            limit || 10,
        )
    });

    return {
        reportsLogsData: data?.data?.logs,
        reportsLogsMeta: {
            totalPages: data?.data?.totalPages,
            currentPage: data?.data?.currentPage,
            totalCount: data?.data?.totalCount
        },
        reportsLogsError: error,
        reportsLogsIsLoading: isLoading,
    };
}